import { ShippingEstimate } from './shipping-estimates.model';
import { ShippingResponse } from './shipping-response.model';

export class ShippingEstimatesResponse {
  estimates: ShippingEstimate[];
  shippingResponse: ShippingResponse;
}
